/** @format */
import Header from "./Header";
import ImageList from "./ImageList";
const Home = () => {
  return (
    <>
      <Header />
      <ImageList />
    </>
  );
};
export default Home;
